import React, { useEffect, useState } from 'react'
import { Dropdown, Fade } from 'react-bootstrap'
import styles from '../search/styles/dropdown.module.scss'
import DropdownLabel, { useForwardedRefOnMount } from '../generic/DropdownLabel'
import cx from 'classnames'
import { KeyItem } from 'types/global'

interface Props<TKey = string> {
  onSelect?: (option: KeyItem<TKey>) => void
  selectedKey: TKey
  options: KeyItem<TKey>[]
  style?: React.CSSProperties
}

const FadeMenu: React.FC<{ show: boolean }> = ({ show, children }, ref) => (
  <Fade {...{ ref, in: show }} unmountOnExit>
    <div className={cx(styles.dropdownMenu, styles.dropdownMenuSmaller)}>{children}</div>
  </Fade>
)

const FilterDropdown = <T,>({ options, onSelect, selectedKey, style }: Props<T>) => {
  //@ts-ignore
  const ForwardedMenu = useForwardedRefOnMount(FadeMenu)
  const [selected, setSelected] = useState(options[0])

  useEffect(() => {
    const controlledSelected = options.find(o => o.key === selectedKey)
    if (controlledSelected) {
      setSelected(controlledSelected)
    }
  }, [options, setSelected, selectedKey])

  return (
    <Dropdown
      className={cx(styles.dropdown, styles.mb32, 'dropdown_dropdown--override')}
      style={style}
    >
      <DropdownLabel label={selected.label} />
      <Dropdown.Menu as={ForwardedMenu}>
        {options.map(opt => (
          <Dropdown.Item
            key={opt.label}
            className={cx(styles.dropdownHover, 'dropdown_dropdownHover--override', {
              [styles.selectedKey]: opt.key === selectedKey,
            })}
            onClick={() => {
              setSelected(opt)
              onSelect && onSelect(opt)
            }}
          >
            {opt.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default FilterDropdown
